import React from 'react';
import { Target, ShieldCheck, Wallet, Building2, HandHeart, Smartphone } from 'lucide-react';
import { features } from '../../mock/mockData';

const iconMap = { Target, ShieldCheck, Wallet, Building2, HandHeart, Smartphone };

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-slate-50/50">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-teal-600 text-sm font-bold uppercase tracking-widest">Pourquoi Medelia ?</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-3 tracking-tight">Une solution complète pour votre formation</h2>
          <p className="text-slate-600 mt-4">Nous simplifions chaque étape de votre formation continue, de la sélection au financement.</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => {
            const Icon = iconMap[f.icon];
            return (
              <div key={i} className="group bg-white border border-slate-200 rounded-2xl p-7 hover:border-teal-400 hover:shadow-xl hover:shadow-teal-500/10 transition-all duration-300 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-teal-50 to-transparent rounded-full -translate-y-12 translate-x-12 group-hover:scale-125 transition-transform duration-500" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-teal-500 to-emerald-600 flex items-center justify-center shadow-md shadow-teal-500/25 mb-5">
                    <Icon className="w-6 h-6 text-white" strokeWidth={2} />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2 leading-snug">{f.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
